import { Divider, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import WSSelectField from "../../Components/Select/WSSelect";
import { useForm, useFormContext } from "react-hook-form";
import { customValidation, validations } from "../../commonFunctions/CommonFunctions";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { WSIcons } from "../../commonFunctions/iIcons";

export const GstAddress: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();

  return (
    <Grid container spacing={2} alignItems="flex-start">
      {/* Left Section */}
      <Grid item xs={12} md={5}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <WSSelectField
              rules={{ required: false }}
              {...register("gstType")}
              id="gstType"
              control={control}
              defaultValue={"0"}
              label="GST Type"
              name="gstType"
            />
          </Grid>
          <Grid item>
            <WSSelectField
              rules={{ required: false }}
              {...register("state")}
              id="state"
              control={control}
              defaultValue={"0"}
              label="State"
              name="state"
            />
          </Grid>
          <Grid item>
            <WSTextField
              className="form-control"
              id="email"
              type={TextType.Text}
              rules={customValidation(false, validations.email)}
              {...register("email")}
              label="Email"
              control={control}
            />
          </Grid>
        </Grid>
      </Grid>

    
      {/* Right Section */}
      <Grid item xs={12} md={6}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <WSTextAreaField
              label={"Billing Address"}
              id={"billingAddress"}
              name={"billingAddress"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
          <Grid item>
          <span style={{color:"blue"}}><WSIcons.AddIcon /> Enable Shipping Address</span> 
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
